module.exports = __webpack_public_path__ + "static/media/19.a7b027e1.jpeg";